type LocationBits = {
  search: string
  hash: string
}

export function readAuthCallbackParams(location: LocationBits) {
  const searchParams = new URLSearchParams(location.search)
  const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''))

  return {
    code: searchParams.get('code'),
    type: searchParams.get('type') ?? hashParams.get('type'),
    tokenHash: searchParams.get('token_hash'),
    accessToken: searchParams.get('access_token') ?? hashParams.get('access_token'),
    refreshToken: searchParams.get('refresh_token') ?? hashParams.get('refresh_token'),
  }
}

export function hasSignupCallbackParams(location: LocationBits) {
  const params = readAuthCallbackParams(location)
  return Boolean(
    params.type === 'signup' ||
      params.code ||
      params.tokenHash ||
      params.accessToken ||
      params.refreshToken,
  )
}

export function buildCallbackRedirect(path: string, location: LocationBits) {
  return `${path}${location.search}${location.hash}`
}
